
/* Minimal reusable fit-selector enhancement for the native Shopify product grid.
   Without JavaScript the photo cards continue to link to the all-products section. */
(function () {
  'use strict';

  function getSale() {
    return document.querySelector('[data-fishe-sale]');
  }

  function setFilter(value, shouldScroll) {
    var sale = getSale();
    if (!sale) return;

    var requested = value || 'all';
    var products = sale.querySelectorAll('[data-fishe-sale-item]');
    var controls = sale.querySelectorAll('[data-fishe-filter-control]');
    var count = 0;

    products.forEach(function (product) {
      var match = requested === 'all' || product.getAttribute('data-fishe-fit') === requested;
      product.hidden = !match;
      if (match) count += 1;
    });

    controls.forEach(function (control) {
      var active = control.getAttribute('data-fishe-filter-control') === requested;
      control.setAttribute('aria-pressed', active ? 'true' : 'false');
      control.classList.toggle('is-active', active);
    });

    var resultCount = sale.querySelector('[data-fishe-sale-count]');
    if (resultCount) resultCount.textContent = String(count);

    if (shouldScroll) {
      var target = document.getElementById('fishe-sale-products');
      if (target) {
        var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      }
    }
  }

  document.addEventListener('click', function (event) {
    var styleLink = event.target.closest('[data-fishe-fit-link]');
    if (styleLink) {
      if (!getSale()) return;
      event.preventDefault();
      setFilter(styleLink.getAttribute('data-fishe-fit-link'), true);
      return;
    }

    var filterButton = event.target.closest('[data-fishe-filter-control]');
    if (filterButton) {
      setFilter(filterButton.getAttribute('data-fishe-filter-control'), false);
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-fishe-sale]')) {
      setFilter('all', false);
    }
  });
})();
